import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">SolidlyAI</div>
        <p className="footer-text">
          We are a founder-led AI & data implementation company. <br />
          We help companies turn vague AI ambitions into real-world systems that deliver measurable impact.
        </p>
        <div className="footer-badges">
          <span className="footer-badge">Virginia, USA</span>
          <span className="footer-badge">Full-Stack AI Delivery</span>
          <span className="footer-badge">Production-Ready Solutions</span>
        </div>
        <div className="footer-contact">
          <p>Ready to discuss your AI strategy? Email <a href="mailto:alek@solidly.ai">alek@solidly.ai</a></p>
        </div>
        <div className="footer-links">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/projects" className="footer-link">All Projects</Link>
          <a href="mailto:alek@solidly.ai" className="footer-link">Contact</a>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 SolidlyAI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;